import en from './en.json';
import es from './es.json';
import de from './de.json';
import cs from './cs.json';
import ja from './ja.json';
import sk from './sk.json';
import it from './it.json';
import zh from './zh.json';

export default {
  en,
  es,
  de,
  cs,
  ja,
  sk,
  it,
  zh,
};
